var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "status-scheduled-date" },
    [
      _c("c-icon", { attrs: { icon: _vm.statusIcon } }),
      _c("div", [_vm._v(_vm._s(_vm.date))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }